module.exports = __webpack_public_path__ + "img/8-full-md.4cbb292f.jpg";